/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * TD factura completa (23 oct 2026). Complementa <td-factura> de assets/td-variantes.js:
 * al carrito (y por lo tanto al pedido y a Sync-E) solo llegan datos de factura COMPLETOS.
 * Si el cliente marca "Necesito factura" y deja algo sin llenar, el carrito queda sin factura aunque llegue a pagar
 * por otro camino (p. ej. una pestaña de pago que ya tenía abierta). Lo que va escribiendo se guarda como borrador
 * en el navegador (sessionStorage) para no perderlo al recargar.
 */
(function () {
  if (!window.customElements) return;
  var LLAVE = 'td-factura-borrador';
  var VACIO = { 'Factura': '', 'RFC': '', 'Razón social': '', 'Régimen fiscal': '', 'Uso CFDI': '', 'CP fiscal': '', 'Correo factura': '' };
  function leer() { try { return JSON.parse(window.sessionStorage.getItem(LLAVE) || 'null'); } catch (e) { return null; } }
  function guardar(data) { try { window.sessionStorage.setItem(LLAVE, JSON.stringify(data)); } catch (e) { /* sin almacenamiento */ } }

  function preparar(el) {
    if (!el.check || el._tdCompleta) return;
    el._tdCompleta = true;
    if (!el.check.checked) {
      var borrador = leer();
      if (borrador && borrador.on) { el.restore(borrador); el.refresh(false); }
    } else {
      el.refresh(false);
      // Un carrito que ya traía factura a medias (de antes de este cambio) se limpia.
      if (el.isBlocking()) el.queueSave(true);
    }
  }

  window.customElements.whenDefined('td-factura').then(function () {
    var P = window.customElements.get('td-factura').prototype;
    if (P._tdCompletaParche) return;
    P._tdCompletaParche = true;

    var values = P.values;
    P.values = function () {
      if (this.check && this.check.checked && this.isBlocking()) return Object.assign({}, VACIO);
      return values.call(this);
    };
    var queueSave = P.queueSave;
    P.queueSave = function (now) {
      guardar(this.snapshot());
      return queueSave.call(this, now);
    };
    var connected = P.connectedCallback;
    P.connectedCallback = function () {
      connected.call(this);
      preparar(this);
    };
    Array.prototype.forEach.call(document.querySelectorAll('td-factura'), preparar);
  });
})();
